import { ReactComponent as InstagramIco } from '../../assets/svg/socials/instagram.svg';
import { ReactComponent as TelegramIco } from '../../assets/svg/socials/telegram.svg';
import { ReactComponent as TwitterIco } from '../../assets/svg/socials/twitter.svg';
import { ReactComponent as YouTubeIco } from '../../assets/svg/socials/youtube.svg';
import { TQuestIconType } from '../../types';

const getSocialIcon = (type: TQuestIconType) => {
  switch (type) {
    case 'telegram':
      return TelegramIco;
    case 'twitter':
      return TwitterIco;
    case 'youtube':
      return YouTubeIco;
    case 'instagram':
      return InstagramIco;
    default:
      return TelegramIco;
  }
};

export default getSocialIcon;
